import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const OktaContentIntro = () => {
  const { t } = useTranslation();
  return (
    <div className="okta-intro" id="okta_intro">
      <div className="title">{t("solution.okta.intro.title")}</div>
      <div className="overview">
        <p>{t("solution.okta.intro.description1")}</p>
      </div>
      <div className="data-warp">
        <div className="item">
          <div className="item-img" style={{ width: 160, marginBottom: 32 }}>
            <img src="//files.authing.co/authing-website/solution-okta-logo.png" alt="authing okta intro" />
          </div>
          <div className="item-img" style={{ width: 220 }}>
            <img src="//files.authing.co/authing-website/solution-okta-num.png" alt="authing okta intro" />
          </div>
          <div className="label">{t("solution.okta.intro.incomeLabel")}</div>
        </div>
        <div className="item">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ marginBottom: 20 }}>
              <div className="item-img" style={{ width: 70 }}>
                <img
                  src="//files.authing.co/authing-website/solution-okta-employee-num.png"
                  alt="authing okta employee"
                />
              </div>
              <div className="label">{t("solution.okta.intro.employeeLable")}</div>
            </div>
            <div>
              <div className="item-img" style={{ width: 70 }}>
                <img
                  src="//files.authing.co/authing-website/solution-okta-employee-num.png"
                  alt="authing okta employee"
                />
              </div>
              <div className="label">{t("solution.okta.intro.customerLabel")}</div>
            </div>
          </div>
          <div>
            <div className="item-img" style={{ width: 210 }}>
              <img
                src="//files.authing.co/authing-website/solution-okta--register-num.png"
                alt="authing okta register"
              />
            </div>
            <div className="label">{t("solution.okta.intro.registerLabel")}</div>
          </div>
        </div>
        <div className="item" style={{ display: "flex", alignItems: "center" }}>
          <div className="item-img">
            <img src="//files.authing.co/authing-website/solution-okta-map.png" alt="authing okta map" />
          </div>
        </div>
      </div>
      <div className="overview">
        <p>{t("solution.okta.intro.description2")}</p>
        <p>{t("solution.okta.intro.description3")}</p>
      </div>
    </div>
  );
};
